var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row gutter-sm" }, [
      _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
        _c("span", { staticClass: "q-headline text-weight-light" }, [
          _vm._v(_vm._s(_vm.$t("user_data")))
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-4" },
        [
          _c("q-input", {
            attrs: { "float-label": _vm.$t("name"), disable: "" },
            model: {
              value: _vm.user_full_name,
              callback: function($$v) {
                _vm.user_full_name = $$v
              },
              expression: "user_full_name"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-4" },
        [
          _c("q-input", {
            attrs: { "float-label": _vm.$t("email"), disable: "" },
            model: {
              value: _vm.user_email,
              callback: function($$v) {
                _vm.user_email = $$v
              },
              expression: "user_email"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-4" },
        [
          _c("q-input", {
            attrs: { "float-label": _vm.$t("level"), disable: "" },
            model: {
              value: _vm.reward_level_title,
              callback: function($$v) {
                _vm.reward_level_title = $$v
              },
              expression: "reward_level_title"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-6" },
        [
          _c("q-input", {
            attrs: { "float-label": _vm.$t("total_points"), disable: "" },
            model: {
              value: _vm.total_earned_points,
              callback: function($$v) {
                _vm.total_earned_points = $$v
              },
              expression: "total_earned_points"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-6" },
        [
          _c("q-input", {
            attrs: { "float-label": _vm.$t("points_for_use"), disable: "" },
            model: {
              value: _vm.user_current_points,
              callback: function($$v) {
                _vm.user_current_points = $$v
              },
              expression: "user_current_points"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }